import { FiSearch } from "react-icons/fi";
import { useState, useEffect, useMemo } from "react";
import { Button, Form, Table } from "react-bootstrap";
import { NoDataFoundTable } from "../../../Hooks/NoDataFoundTable";
import { categoryServices } from "../../../APIServices/VoultManagement/categoryServices";
import {
  FaEdit,
  FaLock,
  FaLockOpen,
  FaPlus,
  FaRegTrashAlt,
  FaTrashAlt,
} from "react-icons/fa";
import Swal from "sweetalert2";
import UseToggle from "../../../Hooks/UseToggle";
import Pagination from "../../../Hooks/Pagination";
import AddNewCategoryMeta from "./AddNewCategoryMeta";
import UpdateCategoryMeta from "./UpdateCategoryMeta";
import DeletedCategoryMetadata from "./DeletedCategoryMetadata";
import Moment from "react-moment";

const CategoryMetaManagement = () => {
  const toggles = UseToggle();

  const [searchData, setSearchData] = useState("");
  const [categoryMetaList, setCategoryMetaList] = useState([]);
  const [categoryMetaCount, setCategoryMetaCount] = useState(0);

  const [deletedCategoryMeta, setDeletedCategoryMeta] = useState([]);
  const [deletedCategoryMetaCount, setDeletedCategoryMetaCount] = useState(0);

  const [categoryMetadata, setCategoryMetadata] = useState("");
  const [openPreview, setOpenPreview] = useState(false);
  const [openModule, setOpenModule] = useState("preview");
  const [previewImage, setPreviewImage] = useState(null);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [copied, setCopied] = useState(false);

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(categoryMetaCount / itemsPerPage);

  const [pageNumberDeleted, setPageNumberDeleted] = useState(1);
  const [itemsPerPageDeleted, setItemsPerPageDeleted] = useState(10);

  const getCategoryList = async () => {
    let data = await categoryServices.getCategoryList(
      "active",
      searchData,
      pageNumber,
      itemsPerPage
    );
    setCategoryMetaList(data?.data || []);
    setCategoryMetaCount(data?.count || 0);
  };

  const getDeletedCategoryList = async () => {
    let data = await categoryServices.getCategoryList(
      "deleted",
      "",
      pageNumberDeleted,
      itemsPerPageDeleted
    );
    setDeletedCategoryMeta(data?.data || []);
    setDeletedCategoryMetaCount(data?.count || 0);
  };

  const softDeleteRestoreCategory = async (categoryId, type) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${type} metadata?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: `Yes, ${type} it!`,
    }).then(async (result) => {
      if (!result.isConfirmed) return;
      const userData = { categoryId, type };
      const data = await categoryServices.softDeleteRestoreCategory(userData);
      if (data?.statusCode === 200) {
        getCategoryList();
        getDeletedCategoryList();
      }
    });
  };

  const updatedCategory = async (categoryId, lockStatus) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${lockStatus ? "lock" : "unlock"} metadata?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then(async (result) => {
      if (!result.isConfirmed) return;
      const userData = { categoryId, lockType: true, lockStatus };
      const data = await categoryServices.updatedCategory(userData);
      if (data?.statusCode === 200) getCategoryList();
    });
  };

  const copyImageUrl = async () => {
    if (!previewImage) return;
    await navigator.clipboard.writeText(previewImage);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  useEffect(() => {
    getCategoryList();
  }, [searchData, pageNumber, itemsPerPage]);

  const activityLogs = [
    {
      _id: "685fe349e3572b7f40c4253a",
      uniqueId: "4159063841",
      activityBy: "fgifa9202089",
      category: "studyeventformschema",
      activities: "Schema Name have been successfully added to the Schema.",
      updatedValue: "Schema001",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:42:49.480Z",
      updatedAt: "2025-06-28T12:42:49.480Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe349e3572b7f40c4253b",
      uniqueId: "4159063841",
      activityBy: "fgifa9202089",
      category: "studyeventformschema",
      activities: "Assign Date have been successfully added to the Schema.",
      updatedValue: "2025-06-18",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:42:49.480Z",
      updatedAt: "2025-06-28T12:42:49.480Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe38ce3572b7f40c42594",
      uniqueId: "9221752978",
      activityBy: "fgifa9202089",
      category: "eventMetadata",
      activities: "Column Label has been successfully added to the event metadata.",
      updatedValue: "Event Number",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:43:56.257Z",
      updatedAt: "2025-06-28T12:43:56.257Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe38ce3572b7f40c42595",
      uniqueId: "9221752978",
      activityBy: "fgifa9202089",
      category: "eventMetadata",
      activities: "Column Name has been successfully added to the event metadata.",
      updatedValue: "EVENNUM",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:43:56.257Z",
      updatedAt: "2025-06-28T12:43:56.257Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe38ce3572b7f40c42596",
      uniqueId: "9221752978",
      activityBy: "fgifa9202089",
      category: "eventMetadata",
      activities: "Column Type has been successfully added to the event metadata.",
      updatedValue: "text",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:43:56.257Z",
      updatedAt: "2025-06-28T12:43:56.257Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe39ae3572b7f40c4259b",
      uniqueId: "8479077403",
      activityBy: "fgifa9202089",
      category: "eventMetadata",
      activities: "Column Label has been successfully added to the event metadata.",
      updatedValue: "Event Name",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:44:10.999Z",
      updatedAt: "2025-06-28T12:44:10.999Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe39ae3572b7f40c4259c",
      uniqueId: "8479077403",
      activityBy: "fgifa9202089",
      category: "eventMetadata",
      activities: "Column Name has been successfully added to the event metadata.",
      updatedValue: "EVENTNAM",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:44:10.999Z",
      updatedAt: "2025-06-28T12:44:10.999Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe39ae3572b7f40c4259d",
      uniqueId: "8479077403",
      activityBy: "fgifa9202089",
      category: "eventMetadata",
      activities: "Column Type has been successfully added to the event metadata.",
      updatedValue: "text",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:44:10.999Z",
      updatedAt: "2025-06-28T12:44:10.999Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe3b0e3572b7f40c425b2",
      uniqueId: "2902156162",
      activityBy: "fgifa9202089",
      category: "eventData",
      activities: "Event Id have been successfully added.",
      updatedValue: "V0_SCR",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:44:32.481Z",
      updatedAt: "2025-06-28T12:44:32.481Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe3b0e3572b7f40c425b3",
      uniqueId: "2902156162",
      activityBy: "fgifa9202089",
      category: "eventData",
      activities: "Event Label have been successfully added.",
      updatedValue: "Screening",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:44:32.481Z",
      updatedAt: "2025-06-28T12:44:32.481Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe3b0e3572b7f40c425b4",
      uniqueId: "2902156162",
      activityBy: "fgifa9202089",
      category: "eventData",
      activities: "Event Day have been successfully added.",
      updatedValue: "-30",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:44:32.481Z",
      updatedAt: "2025-06-28T12:44:32.481Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe3b0e3572b7f40c425b5",
      uniqueId: "2902156162",
      activityBy: "fgifa9202089",
      category: "eventData",
      activities: "Event Name have been successfully added.",
      updatedValue: "Screening",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:44:32.481Z",
      updatedAt: "2025-06-28T12:44:32.481Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe3b1e3572b7f40c425c2",
      uniqueId: "9112213509",
      activityBy: "fgifa9202089",
      category: "eventData",
      activities: "Event Id have been successfully added.",
      updatedValue: "V1_D0",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:44:33.673Z",
      updatedAt: "2025-06-28T12:44:33.673Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe3b1e3572b7f40c425c3",
      uniqueId: "9112213509",
      activityBy: "fgifa9202089",
      category: "eventData",
      activities: "Event Label have been successfully added.",
      updatedValue: "Visit 1 Day 0",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:44:33.673Z",
      updatedAt: "2025-06-28T12:44:33.673Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe3b1e3572b7f40c425c4",
      uniqueId: "9112213509",
      activityBy: "fgifa9202089",
      category: "eventData",
      activities: "Event Day have been successfully added.",
      updatedValue: "0",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:44:33.673Z",
      updatedAt: "2025-06-28T12:44:33.673Z",
      fullName: "Gaurav Chauhan"
    }
  ]

  const CategoryActivity = useMemo(() => {
    const grouped = {};

    activityLogs.forEach((item) => {
      const date = new Date(item.createdAt).toISOString().split("T")[0];
      if (!grouped[date]) grouped[date] = [];

      grouped[date].push({
        module: item.category || "Unknown Module",
        type: item.actionType || "Unknown Type",
        activities: item.activities,
        prevoiusValue: item.prevoiusValue,
        updatedValue: item.updatedValue,
        activityByName: item.fullName,
        createdAt: item.createdAt,
      });
    });

    return Object.entries(grouped)
      .map(([date, data]) => ({
        date,
        data: data.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        ),
      }))
      .sort((a, b) => new Date(b.date) - new Date(a.date));
  }, [activityLogs]);

  return (
    <div style={{background: "#eee"}}>
      

      <div className="p-2 d-flex gap-2">
        <div className={`meta-table overflow-auto ${openPreview ? "shrink" : ""}`} style={{height: "calc(100vh - 71px)"}}>
          <div className="hstack gap-2 pb-2 bg-white">
            <Button
              size="sm"
              variant="outline-primary"
              className="hstack gap-2 text-nowrap rounded-1 border"
              style={{ fontSize: 13 }}
              onClick={toggles.setToggle}
            >
              <FaPlus /> Add New Meta
            </Button>
            <div className="search-box position-relative w-100">
              <FiSearch />
              <Form.Control
                type="search"
                className="w-100 rounded-1"
                style={{ fontSize: 13 }}
                placeholder="Search..."
                value={searchData}
                onChange={(e) => setSearchData(e.target.value)}
              />
            </div>
            {deletedCategoryMetaCount > 0 && (
              <Button
                size="sm"
                variant="outline-danger"
                className="hstack gap-2 text-nowrap rounded-1 border"
                style={{ fontSize: 13 }}
                onClick={toggles.setToggle2}
              >
                <FaRegTrashAlt /> Deleted History
              </Button>
            )}
          </div>
          <div className="overflow-auto" style={{ height: "calc(100vh - 122px)"}}>
            {categoryMetaCount === 0 ? (
              <NoDataFoundTable MSG="No Category Metadata." />
            ) : (
              <>
                <Table hover responsive className="">
                  <thead className="position-sticky" style={{top: -1}}>
                    <tr>
                      <th style={{width: 45}} className="text-center">Sr.</th>
                      <th>Name</th>
                      <th className="text-center">URL</th>
                      <th className="text-center">Lock</th>
                      <th className="text-center" style={{width: 80}}>Actions</th>
                    </tr>
                  </thead>

                  <tbody>
                    {categoryMetaList.map((item, index) => (
                      <tr
                        key={item.categoryId}
                        className={ selectedRowId === item.categoryId ? "selectedRow CP" : "CP"}
                        onClick={() => {
                          setOpenPreview(true);
                          setPreviewImage(item.icon);
                          setSelectedRowId(item.categoryId);
                        }}
                      >
                        <td className="text-center">{startIndex + index + 1}</td>
                        <td>
                          <strong>{item.name}</strong>
                          <div className="sub-text">{item.key}</div>
                        </td>
                        <td className="text-center">
                          {item.icon ? "Yes":  "No"}
                        </td>

                        <td
                          className="text-center CP"
                          title="Lock Status"
                          onClick={(e) => {
                            e.stopPropagation();
                            updatedCategory(item.categoryId, !item.lockStatus);
                          }}
                        >
                          {item.lockStatus ? (
                            <FaLock className="text-success" />
                          ) : (
                            <FaLockOpen className="text-danger" />
                          )}
                        </td>

                        <td className="text-center actions">
                          <FaEdit
                            title="Edit"
                            className={`icon CP ${ item.lockStatus ? "disabled" : ""}`}
                            onClick={(e) => {
                              e.stopPropagation();
                              if (!item.lockStatus) {
                                toggles.setToggle1();
                                setCategoryMetadata(item);
                              }
                            }}
                          />

                          <FaTrashAlt
                            title="Delete"
                            className={`icon danger CP ${item.lockStatus ? "disabled" : ""}`}
                            onClick={(e) => {
                              e.stopPropagation();
                              if (!item.lockStatus) {
                                softDeleteRestoreCategory(
                                  item.categoryId,
                                  "delete"
                                );
                              }
                            }}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <div className="position-sticky bottom-0 start-0">
                  <Pagination
                    totalPage={totalPage}
                    pageNumber={pageNumber}
                    itemsPerPage={itemsPerPage}
                    totalItems={categoryMetaCount}
                    setPageNumber={setPageNumber}
                    setItemsPerPage={setItemsPerPage}
                  />
                </div>
              </>
            )}
          </div>
        </div>

        {openPreview && (
          <div className="meta-preview">
            <div className="preview-header hstack justify-content-between">
              <div className="hstack gap-2">
                <Button size="sm" variant={ openModule === "preview" ? "primary" : "outline-primary"} onClick={() => setOpenModule("preview")}>Preview</Button>
                <Button size="sm" variant={ openModule === "activity" ? "primary" : "outline-primary"} onClick={() => setOpenModule("activity")}>Activity</Button>
              </div>
              <Button size="sm" variant="outline-danger" onClick={() => {setOpenPreview(false); setPreviewImage(null);}}>Close</Button>
            </div>

              {openModule === "preview" && previewImage && (
               <>
                  <div className="overflow-auto" style={{height: "calc(100vh - 175px)"}}>
                    <div className="preview-body">
                      <img src={previewImage} alt="Preview" />
                    </div>
                  </div>
                  <div className="preview-footer">
                    <Button size="sm" variant="outline-primary" onClick={copyImageUrl}>{copied ? "Copied" : "Copy URL"}</Button>
                  </div>
                </>
              )}
              {openModule === "activity" && (
                <div className="p-2 bg-light overflow-auto" style={{height: "calc(100vh - 124px)"}}>
                  {CategoryActivity.map(({ date, data }, index) => (
                    <div key={index}>
                      {data?.map((item, key) => (
                        <div key={key} className="activity__section">
                          <div className="w-100">
                            <p style={{fontSize: 12}} className="m-0">Previous Value : {item?.previousValue}</p>
                            <p style={{fontSize: 12}} className="mb-1">Updated Value : {item?.updatedValue}</p>
                            <ul className="m-0 p-0">
                              <li>
                                <p className="m-0 text-muted" style={{fontSize: 12}}>
                                  <span className="text-capitalize" style={{ fontWeight: 600 }}>
                                    {item.type}{": "}
                                  </span>
                                  {item.activities}
                                </p>
                              </li>
                            </ul>
                            <div className="mt-1 d-flex justify-content-between">
                              <Form.Label className="m-0 text-muted" style={{fontSize: 12}}>
                                <Moment format="DD MMM YYYY | HH:mm" withTitle>
                                  {item?.createdAt}
                                </Moment>
                              </Form.Label>
                              <Form.Label className="m-0 text-muted" style={{fontSize: 12}}>
                                By: {item?.activityByName}
                              </Form.Label>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              )}
          </div>
        )}
      </div>

      <AddNewCategoryMeta
        Show={!toggles.toggle}
        Hide={toggles.setToggle}
        Title={`Add New Category`}
        getCategoryList={getCategoryList}
      />

      <UpdateCategoryMeta
        Show={!toggles.toggle1}
        Hide={toggles.setToggle1}
        Title={`Update Category`}
        categoryMetadata={categoryMetadata}
        getCategoryList={getCategoryList}
      />

      <DeletedCategoryMetadata
        Show={!toggles.toggle2}
        Hide={toggles.setToggle2}
        Title={`Restore Categories`}
        deletedCategoryMeta={deletedCategoryMeta}
        softDeleteRestoreCategory={softDeleteRestoreCategory}
        deletedCategoryMetaCount={deletedCategoryMetaCount}
        pageNumberDeleted={pageNumberDeleted}
        itemsPerPageDeleted={itemsPerPageDeleted}
        setPageNumberDeleted={setPageNumberDeleted}
        setItemsPerPageDeleted={setItemsPerPageDeleted}
        getDeletedCategoryList={getDeletedCategoryList}
      />
    </div>
  );
};

export default CategoryMetaManagement;
